module.exports = __webpack_public_path__ + "static/img/nav3.867220b9.svg";